import React from 'react';
import { connect } from 'react-redux'
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core';
import GeneralButton from '../../../../components/Common/AllButton/AllButton';
import goTo from '../../../../actions/goTo';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
    container: {
        marginTop: 10,
        marginRight: 10,
        width: 206,
        maxWidth: 206,
        height: 350,
        position: 'relative',
        borderRadius: 4,
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14)',
        '&:last-child': {
            marginRight: 0
        },  
    },
    img: {
        objectFit: 'cover',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        width: 206,
        height: 204,
    },
    icon: {
        color: 'white',
        width: 60,
        height: 60,
    },
    content: {
        height: 146,
        background: 'rgba(0,0,0,0.2)',
        flexDirection: 'row',
        position: 'absolute',
        width: '100%'
    },
    title: {
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline',
            textDecorationColor: 'rgba(255,255,255,1)'
        },
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: 'nowrap',
        marginRight: 6,
        marginLeft: 6,
        marginTop: 18,
        marginBottom: 6,
        fontFamily: 'Rubik',
        fontSize: 18,
        fontWeight: '500',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#fff',
    },
    subtitle: {
        height: 17,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: 'nowrap',
        marginTop: 8,
        marginRight: 8,
        marginLeft: 8,
        fontFamily: 'Rubik',
        fontSize: 14,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.43,
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#fff',
    },
    subsribeButtomContainer: {
        width: 130,
        height: 38,
        backgroundColor: 'transparent',
        border: 'solid 2px #e0e0e0',
        color: '#fff',
        '&:hover': {
            background: '#FFF',
            color: '#21212d',
        },
    },
    subsribeButtomText: {
        fontSize: 14,
        lineHeight: 2,
        letterSpacing: 1.5,
        marginTop: 2
    },
    unsubsribeButtomContainer: {
        width: 130,
        height: 38,
        backgroundColor: '#fff',
        border: 'solid 2px #fff',
        color: '#21212d',
        '&:hover': {
            background: 'transparent',
            color: '#fff',
        },
    },
    subsribe: {
        marginTop: 16,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center'
    },
});


const checkIfSubscribed = (tag, userData) => {    
    if(userData.subscribedTags && userData.subscribedTags.length && tag){
        return userData.subscribedTags.some(t => (t.tag || "").toLowerCase() === tag.toLowerCase())
    }
    return false
}

const Person = (props) => {
    const {classes, person, dispatch, userData, subscribe, t} = props
    const {backgroundImage} = person
    const isSubsribed = checkIfSubscribed(person.tag, userData)

    const onClickGeneral = () => {
        if(isSubsribed) {
            openUser()
            return
        }
        subscribe(person.meta, openUser)
    }
    const renderSubscribeButton = () => {
        const title = isSubsribed ? t('VIEW') : t('SUBSCRIBE')
        const containerStyle = isSubsribed ? classes.unsubsribeButtomContainer : classes.subsribeButtomContainer
        return <GeneralButton onClick={onClickGeneral} containerStyle={containerStyle} textStyle={classes.subsribeButtomText} title={title} />
    }
    const openUser = () => {
        const { tag } = person
        let userTagFormat = ''
        if (!tag.startsWith('@')) {
            userTagFormat = `@`
        }
        userTagFormat += tag.replace(' ', '').toLowerCase()
        goTo(userTagFormat, dispatch)()
    }

        return (
            <div data-intrcm-id="Person_ccydxlx5" className={classes.container}>
                <img alt="person" src={backgroundImage} className={classes.img} />
                <div data-intrcm-id="Person_ibc8t25a" style={{backgroundColor: person.backgroundColor}} className={classes.content}>
                    <div data-intrcm-id="Person_bqvu8wap" onClick={openUser} className={classes.title}>{person.title}</div>
                    <div data-intrcm-id="Person_p9u1090j" className={classes.subtitle}>{person.subtitle}</div>
                    <div data-intrcm-id="Person_88h2ja1k" className={classes.subsribe}>{renderSubscribeButton()}</div>
                </div>
          </div>
        )
}

const mapStateToProps = (state) => ({
    userData: state.userData
})


const mapDispatchToProps = dispatch => ({ dispatch })

export default compose(withStyles(styles, {withTheme: true}),
    withTranslation('groupDrawerTranslate'),
    connect(mapStateToProps, mapDispatchToProps))(Person);
